import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import Seo from "@/components/feature/Seo";
import FaqAccordion from "@/components/feature/FaqAccordion";
import Breadcrumbs from "@/components/base/Breadcrumbs";
import { faqs } from "@/mocks/site";

const BASE = "https://danmeimh.net.cn";

export default function Faq() {
  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqs.map((item) => ({
        "@type": "Question",
        name: item.question,
        acceptedAnswer: { "@type": "Answer", text: item.answer },
      })),
    },
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "首页", item: `${BASE}/` },
        { "@type": "ListItem", position: 2, name: "常见问题", item: `${BASE}/faq` },
      ],
    },
  ];

  return (
    <SiteLayout>
      <Seo
        title="常见问题 | 黑料每日更新与内容原则说明"
        description="黑料每日常见问题解答：更新频率、内容筛选标准、投稿报料方式、转载规则与广告合作方式，一次说清楚。"
        keywords="黑料每日常见问题,更新频率,投稿报料,内容原则,转载规则"
        canonicalPath="/faq"
        jsonLd={jsonLd}
      />
      <div className="px-4 md:px-8">
        <Breadcrumbs items={[{ label: "常见问题" }]} />
      </div>

      <section className="px-4 md:px-8 pb-6 border-b border-background-200">
        <span className="inline-flex items-center gap-1.5 text-[11px] font-medium tracking-[0.2em] text-accent-700 uppercase mb-2">
          <span className="w-6 h-px bg-accent-500" />
          FAQ
        </span>
        <h1 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 mb-3">常见问题</h1>
        <p className="text-sm md:text-base text-foreground-600 max-w-3xl leading-relaxed">
          关于更新节奏、内容筛选、投稿报料与合作方式的常见问题，都在这里。如果还有疑问，欢迎通过联系页面告诉我们。
        </p>
      </section>

      <div className="px-4 md:px-8 py-10 grid grid-cols-1 lg:grid-cols-3 gap-10">
        <div className="lg:col-span-2">
          <FaqAccordion items={faqs} />
        </div>
        <aside className="lg:col-span-1">
          <div className="rounded-lg border border-background-200 bg-background-100 p-6">
            <h2 className="font-heading text-lg font-bold text-foreground-950 mb-3">还有别的问题？</h2>
            <p className="text-sm text-foreground-600 leading-relaxed mb-5">
              无论是选题建议、合作咨询还是内容纠错，都可以直接给我们留言，编辑组会在三个工作日内回复。
            </p>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 rounded-md bg-primary-500 text-background-50 px-5 py-3 text-sm hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              <i className="ri-mail-send-line" aria-hidden="true" />
              前往联系我们
            </Link>
          </div>
        </aside>
      </div>
    </SiteLayout>
  );
}